export enum LoginResultEnum {
	Success,
	BadCredentials,
	OtherError,
	RefreshTokenInvalid,
	Refreshing,
	None,
	LoggedOut,
}
